const AboutArticlesEs = () => {
    return (
        <>
            <h2>Miaj Artikoloj</h2>
            <ul className="accordion-ul">
                <li className="accordion-li">
                    <input type="checkbox" defaultChecked={true} />
                    <i className="mg-top-arrow"></i>
                    <h2 className="accordion-title">Akcept la vivon - Akcepti kio estas</h2>
                    <p>
                        Ofte okazas ke membroj de familioj, precipe gepatroj aŭ geavoj, estis energie rompitaj, ilia
                        sorto estis tiel malfacila, ke ili apenaŭ travivis. Tamen havis la forton por transdoni la
                        vivon.
                    </p>
                    <p>
                        La infanoj en tiaj kazoj reagas en du malsamaj manieroj: aŭ ili foriras de familio, forkuras,
                        fermas sin emocie ĉar ĉio estis tro timiga kaj peza por ili, aŭ ili interplektiĝis en la rilatoj
                        kaj provante helpi preskaŭ energidronas de la familiaj ŝarĝoj.
                    </p>
                    <p>
                        Ambaŭ elektoj post iom da tempo devus fari la samon:{' '}
                        <b> akcepti la sorton de la familianoj kaj akcepti sian vivon tia, kia ĝi estas.</b>
                    </p>
                    <p>
                        Tiuj, kiuj forkuris kaj rifuzis partopreni, devas reveni, rigardi, senti la ŝarĝon, vidi la
                        malfacilan sorton sed ankaŭ senti la forton en la rompitaj animoj de antaŭuloj. Kun profunda
                        respekto. En ĉiuj tiuj, kiuj travivis, por ke iliaj posteuloj vivu.
                    </p>
                    <p>
                        Tiuj, kiuj provis helpi, devus retiriĝi, lasi la ŝarĝon al tiuj, al kiuj ĝi apartenas, ĉesu per
                        sia infana amo enplektiĝi en la vivon de aliaj. Rigardi malfacilan sorton kaj senti la forton en
                        rompitaj animoj. Kun profunda respekto. En ĉiuj kiuj travivis por ke iliaj posteuloj vivu.
                    </p>
                    <p>Kaj en ambaŭ kazoj, senti forton, kiu estis transdonita al ili de iliaj pragepatroj.</p>
                    <p>
                        La liberigaj frazoj sonas enigme:{' '}
                        <b>
                            Mi akceptas mian vivon tia kia ĝi estas.
                            <br />
                            Mi ricevis sufiĉe, mi mem prizorgos la ceterajn.
                        </b>
                    </p>
                    <p>
                        Ĉi tie kutime okazas rezisto - mi ricevis sufiĉe!! Mi devus kaj meritis pli!! Mi rajtas plendi,
                        kulpigi, kritiki!!!
                    </p>
                    <p>Jes, Vi meritas pli, sed de tiu fonto vi ricevis tion, kio necesis kaj eblis.</p>
                    <p>
                        Kaj sufiĉis ĉar vi venis al la mondo kaj vi vivas! Kaj vi respondecas prizorgi la reston.
                        <br />
                        Kun nia decido akcepti la vivon tia kia ĝi estas venas nia kapablo ricevi, nia malfermo al la
                        mondo kaj al homoj, nia volemo rimarki kaj eltiri la helpon de la universo/dio/pli alta potenco
                    </p>
                    <p> Kaj tiam ni ricevas helpon abunde kaj diversmaniere.</p>
                    <p>
                        De la flegistino, kiu malsekigas nian buŝon antaŭ operacio, de la onklino, kiu kisas la vundon
                        sur nia kruro, de la instruisto, kiu enŝovas en ni pasion por libroj, de la najbaro, kiu bakas
                        al ni kukojn, de la estro, kiu instruas nin akcepti aŭtoritaton , de la afableco de fremdulo,
                        kiu rimarkas, ke vi estas deprimita...
                    </p>
                    <p>
                        Kaj tie estas nia respondeco vidi, ke VIVO estas kun ni, por rimarki ĉiujn malgrandaj/grandaj
                        donacoj de nia vivo. Kaj esti dankema.
                    </p>
                </li>
                <li className="accordion-li">
                    <input type="checkbox" defaultChecked={true} />
                    <i></i>
                    <h2 className="accordion-title">Esti gepatro de plenkreskulo</h2>
                    <p>
                        Foje, mia filino demandis min, kio por mi estas la plej komplika afero en mia rolo de patrino.
                        La respondo eble surprizis ŝin - la plej malfacilaj estis la konstantaj ŝanĝoj de infanoj, pro
                        kio mi ankaŭ devis konstante ŝanĝi mian rolon kiel patrino kaj la manieron kiel mi komunikis kun
                        ili.
                    </p>
                    <p>
                        Animo de patrino kreiĝas jam en infaneco ricevante prizorgon kaj atenton de gepatroj, onklinoj,
                        avinoj, ĉiujn virinoj en via kulturo kaj klimato. Akceptante la rolon de virino kaj la rolon de
                        patrineco. Tiu animo komence montriĝas tra malklara sento: &quot;iun tagon mi estos
                        patrino&quot;.
                    </p>
                    <p>
                        La sekva paŝo estas partnereco, elekti la patron al viaj infanoj, senti vin sekura por komenci
                        krei neston.
                    </p>
                    <p>
                        Vera preteco estas testita dum gravideco kaj naskiĝo kun la tuta ŝtormo de emocioj, hormonoj,
                        ŝanĝoj de vivkondiĉoj, novaj eblecoj kaj novaj limigoj.Ne estas simple liberigi parton de viaj
                        kapabloj kaj konscie doni ilin al tiu parto de vi, kiu elektas esti patrino. Rearanĝi
                        prioritatojn. Kaj kiel ajn tio estas konfuziga, estas nur la komenco...
                    </p>
                    <p>
                        Mi rapide trairos la interesan parton de konstantaj ŝanĝoj: okupado de spaco de rampado,
                        promenado, kurado, grimpado. Kiam vi alkutimiĝas al la rigardo de senkondiĉa amo, kaj tiam li/ŝi
                        &quot;forlasas&quot; vin kaj ekiras al la aventuroj krei infanajn amikecojn, tiam lernejo kiam
                        la aŭtoritato de la gepatroj estas nuligita favore al la aŭtoritato de la instruisto, tiam la
                        aŭtoritato de amikoj, socio... kaj malrapide via senhelpa &quot;fasko de ĝojo&quot; fariĝas
                        plenkreskulo.
                    </p>
                    <p>Kaj denove komenciĝas nova malfacila parto.</p>
                    <p>
                        Necesas transformiĝi de la gepatro de infanoj al gepatro de plenkreskulo. Starigi novajn limojn.
                    </p>
                    <p>Ĉesu esti maltrankvila gepatro, fariĝi gepatro plena de fido.</p>
                    <p>
                        Ĉesu esti gepatro, kiu donas konsilojn, fariĝi gepatro, kiu pacience subtenas la akiron de
                        spertoj.
                    </p>
                    <p>
                        Fariĝi gepatro, kiu fieras pri propra vivo kaj kiu fieras pri la personoj, kiuj kreiĝis de la
                        iliaj infanoj.
                    </p>
                    <p>Ĉesi esti gepatro, kiu prizorgas infanojn. Rekomenci zorgi pri si mem. </p>
                    <p>
                        Kaj tiam niaj infanoj fariĝas kontentaj ĉar ni estas kontentaj. Gepatroj fidu al gefiloj.
                        Gefiloj respektu gepatrojn. Gefiloj fariĝas liberaj ĉar ni liberigas ilin, tuj kiam ili montras
                        deziron preni respondecon pri si mem.
                    </p>
                    <p>
                        La transira periodo de gepatrado de infano ĝis gepatrado de plenkreskulo estas tre postulema kaj
                        foje konfuza. Ĉar foje infanoj petas de vi konsilon kaj poste koleriĝas pro la manko de fido.
                        Foje ili serĉas konsolon, sed sen enmiksiĝo en ilia decidoj. Ni ĉiuj trejnas kie estas niaj
                        novaj limoj. Ĉiuj estas konfuzitaj en tiu periodo.
                    </p>
                    <p>
                        Tio estas ankaŭ komplika ĉar, foje, al gepatroj remalfermiĝas la spaco, tempo kaj energio por ke
                        gepatroj revenu al sia propra, preskaŭ forgesita kaj foje detruita vivo.
                    </p>
                    <p>
                        Rigardi al sia vivo, rimarki kio estis prokrastita, neglektita, puŝita sub la tapiŝo... ĉar la
                        infanoj havis prioritaton.
                    </p>
                    <p>
                        Kaj nun ne plu ĉeestas infanoj. Geedzoj estas solaj. Patrino sola. Patro sola. Do, gepatroj
                        devas alfronti la problemojn, kiuj ne plu povas esti kaŝitaj, revoki la energion, ĝojon, pasion,
                        ŝatokupojn... Rekonstrui sian novan vivon. Por ke ni plu estu fieraj pri si mem, por ke ni sentu
                        memrespekton por ke niaj plenkreskaj infanoj povu respekti nin.
                    </p>
                </li>
            </ul>
        </>
    );
};

export default AboutArticlesEs;
